﻿/* 
Object:         Header
Description:    This has the logic that will show/hide certain panes like nodetree or module menu when the user clicks on certain buttons in the header.
Used in:        Grid (kendo), Tabstrip (kendo), Module Navigation, Splitter (kendo) 
*/

window.header = function () {

    // Toggle from desktop to mobile layout. Set session var and refresh the browser.
    function toggleLayout() {
        // Set session variable (toggle)
        $.get(appsettings.getUrl("Navigation/ToggleLayout"), function (data) {

            // Refresh Page
            location.reload();

        });
    }

    function toggleSelectedNodeAndModule() {
        // collapse other panes
        var splitter = $("#contentLayout").data('kendoSplitter');

        if ($("#MobileNodeTree").height() == 0 && $("#MobileModuleMenu").height() == 0) {
            splitter.expand($("#OverviewSelectedNodeAndModule"));
            splitter.expand($("#ModuleAreaPane"));
        } else {
            splitter.collapse($("#OverviewSelectedNodeAndModule"));
            splitter.collapse($("#ModuleAreaPane"));
        }

    }

    return {
        initialize: function (isMobile) {
            
            $("#actions-header").hide();

            $("#nodetree-action").click(function () {
                // collapse other panes
                var splitter = $("#contentLayout").data('kendoSplitter');

                // Toggle pane
                var pane = isMobile ? $("#MobileNodeTree") : $("#NodeTree");
                splitter.toggle(pane, isMobile ? pane.height() <= 0 : pane.width() <= 0);

                // Other panes
                if (isMobile) {
                    splitter.collapse($("#MobileModuleMenu"));

                    toggleSelectedNodeAndModule();
                }
            });

            $("#modulemenu-action").click(function () {
                // collapse other panes
                var splitter = $("#contentLayout").data('kendoSplitter');

                // Toggle pane
                var pane = isMobile ? $("#MobileModuleMenu") : $("#ModuleMenu");
                splitter.toggle(pane, isMobile ? pane.height() <= 0 : pane.width() <= 0);

                // Other panes
                if (isMobile) {
                    splitter.collapse($("#MobileNodeTree"));

                    toggleSelectedNodeAndModule();
                }
            });

            $("#userprofile-action").click(function () {
                var splitter = $("#contentLayout").data('kendoSplitter');

                // TODO collapse for mobile the following panes when profile pane is shown:
                // ModuleArea, NodeTree and ModuleMenu
                if (isMobile) {
                    splitter.toggle($("#MobileAccountActionPane"), $("#MobileAccountActionPane").height() <= 0)

                } else {
                    splitter.toggle($("#AccountActionPane"), $("#AccountActionPane").width() <= 0)
                }

            });

            $("#get-options-action").click(function () {
                $("#more-actions-header").hide();
                $("#login-header-left").hide();
                $("#actions-header").show();
            });

            $("#userheader-action").click(function () {
                $("#actions-header").hide();
                $("#login-header-left").show();
                $("#more-actions-header").show();
            });

            $("#mobile-action").click(function () {
                toggleLayout();
            });

            $("#userlogout-action").click(function () {
                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl("Account/Logout"),
                    success: function (responseData) {
                        window.location.assign(appsettings.getUrl("Account/Login"));
                    }
                });
            });
        },

        toggle_selection_navigation_bar: function () {
            // Decide if the bar with selected node / module must be visible or not.
            toggleSelectedNodeAndModule();
        }
    }
}();